import apiService from './apiService'

/**
 * System Settings Service
 * Handles API calls for system statistics and PM2 operations
 * Uses centralized apiService which automatically handles authentication tokens
 */
export default {
  /**
   * Get system statistics (CPU, RAM, PM2 processes)
   * @returns {Promise} - Promise that resolves with system statistics
   */
  async getSystemStats() {
    try {
      // Use the same pattern as other express API calls - baseURL from $expressApi + 'api/' + endpoint
      // The baseURL from $expressApi should be like 'https://liverunapi.npit.xyz/' (without /api/)
      // So we add 'api/system/stats' to get 'https://liverunapi.npit.xyz/api/system/stats'
      const response = await apiService.get('api/system/stats')
      return response
    } catch (error) {
      console.error('Error fetching system statistics:', error)
      throw error
    }
  },

  /**
   * Restart all PM2 processes
   * @returns {Promise} - Promise that resolves when PM2 restart is initiated
   */
  async restartPM2() {
    try {
      // Use the same pattern as other express API calls - baseURL from $expressApi + 'api/' + endpoint
      const response = await apiService.post('api/system/restart-pm2', {})
      return response
    } catch (error) {
      console.error('Error restarting PM2:', error)
      throw error
    }
  }
}




// WEBPACK FOOTER //
// ./src/services/systemSettings.js